export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14686.55b942eb.jpg";